/**
 * Normalize GET /tag-mappings (and similar) responses for UI tables.
 */

/**
 * API may return `isActive` as boolean or numeric 0/1. Coerce for UI logic
 * (`0 !== false` is true in JS, which wrongly showed inactive rows as active).
 * @param {unknown} value
 * @returns {boolean}
 */
export function normalizeIsActive(value) {
  if (value === false || value === 0 || value === "0") return false;
  if (value === true || value === 1 || value === "1") return true;
  if (value == null) return true;
  return Boolean(value);
}

export function extractTagMappingsArray(payload) {
  if (payload == null) return [];
  if (Array.isArray(payload)) return payload;
  const d = payload.data;
  if (Array.isArray(d)) return d;
  if (d && typeof d === "object" && Array.isArray(d.data)) return d.data;
  if (Array.isArray(payload.list)) return payload.list;
  if (Array.isArray(payload.items)) return payload.items;
  return [];
}

/**
 * @param {object} row
 * @param {"CLIENT_TO_ACCOUNTING"|"VENDOR_TO_ACCOUNTING"} mappingType
 */
export function normalizeTagMappingRow(row, mappingType) {
  if (!row || typeof row !== "object") return null;
  const id = row.id ?? row.mappingId;
  const sourceTagId = String(row.sourceTagId ?? row.sourceTag?.id ?? "");
  const targetTagId = String(row.targetTagId ?? row.targetTag?.id ?? "");
  const sourceName =
    row.sourceTag?.name ?? row.sourceName ?? row.sourceTagName ?? (sourceTagId || "—");
  const targetName =
    row.targetTag?.name ??
    row.targetName ??
    row.targetTagName ??
    row.accountingName ??
    (targetTagId || "—");
  return {
    id,
    mappingType: row.mappingType ?? mappingType,
    sourceTagId,
    targetTagId,
    tag: sourceName,
    account: targetName,
  };
}
